import { AuthTokens } from 'app/providers';
import { logger } from 'shared/lib/logger';

const AUTH_TOKENS_KEY = process.env.REACT_APP_AUTH_TOKEN_KEY ?? '';

export const retrieveStoredAuthTokens = (): AuthTokens | null => {
  try {
    const item = localStorage.getItem(AUTH_TOKENS_KEY);
    return item ? JSON.parse(item) : null;
  } catch (error) {
    logger('Failed to get auth token from localStorage:', error, 'error');
    return null;
  }
};

export const storeAuthTokens = (tokens: AuthTokens) => {
  localStorage.setItem(AUTH_TOKENS_KEY, JSON.stringify(tokens));
};

export const removeStoredAuthTokens = () => {
  localStorage.removeItem(AUTH_TOKENS_KEY);
};
